module.exports = __webpack_public_path__ + "img/d6sj-btn.969d7070.png";